import React from 'react';

export default function SafeIcon({ icon, name, className = '', ...props }) {
  // Simple fallback icon as text
  if (!icon) {
    return <span className={className} {...props}>●</span>;
  }
  try {
    return React.createElement(icon, { className, ...props });
  } catch (error) {
    console.warn('SafeIcon error:', error);
    return <span className={className} {...props}>●</span>;
  }
}